import { type ColumnDef } from "@tanstack/react-table"
import { DataTable } from "@components/DataTable/DataTable"
import FilterHeader from "@components/FilterHeader"
import { type IFailedOrders } from "@apis/orders/types"

type Filter = {
  label: string
  value: string
  onChange: (newValue: string) => void
}

interface IFailedOrdersTableProps<TData> {
  columns: ColumnDef<TData, unknown>[]
  data: IFailedOrders[] | undefined
  filters?: Filter[]
  pending?: boolean
}

export const FailedOrdersTable = <TData,>({
  columns,
  data,
  filters = [],
  pending = false,
}: IFailedOrdersTableProps<TData>) => {
  return (
    <div className="tw:w-full tw:space-y-4">
      <FilterHeader
        title="Failed Orders"
        count={data?.length ?? 0}
        filters={filters}
      />
      <DataTable columns={columns} pending={pending} data={data as TData[]} />
    </div>
  )
}
